import React, { PureComponent } from 'react';
import range from 'lodash/range';
import Modal from '../../../../components/Modal';
import { Form, FormGroup, SubmitButton, FormError } from '../../../../components/Forms/Forms';
import { Input, Select, Textarea } from '../../../../components/Forms/fields/index';
import rules from '../../../../components/Forms/rules';
import enums from '../../../../constants/enums';

class AmazonCrossCheckView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      defaultTypeValue: '',
    }
  }
  render() {
    const {
      closeModal,
      crossCheckModalActive,
      formState,
      submitForm,
      onFormUpdate,
      amazonAccounts,
      crossCheckPayments,
      missingCodes,
    } = this.props;

    const selectedAccount = formState.data.account;

    return crossCheckModalActive ? (
      <Modal active={crossCheckModalActive} onClose={closeModal}>
        <div className="amazon-cross-check-modal">
          <h3>Amazon Cross Check</h3>
          <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
            <FormGroup>
              <Select name="account" options={amazonAccounts} emptyOption  validate={[rules.required()]} />
              <FormError/>
            </FormGroup>

            <FormGroup>
              <Textarea name="amazonGiftcardsText" validate={[rules.required()]} />
              <FormError/>
            </FormGroup>

            <div className="actions">
              <button type="submit" className="button">Check</button>
            </div>
          </Form>
          {missingCodes && missingCodes.length > 0 && (
            <div>
              <h4>Missing Payments</h4>
              <div className="missing-codes">
                {missingCodes.map((amazonCode, i)=>(
                  <span key={i}>xxxx-xxxxxx-{amazonCode.code}</span>
                ))}

              </div>
            </div>
          )}
          {crossCheckPayments && (
            <div className="payments">
              <h4>Found Payments</h4>
              <table>
                <tbody>
                {crossCheckPayments.map((payment, i)=>{
                  const channels = payment.channels.filter(channel => channel.account === selectedAccount);;
                  const totalInRightAccount = channels.reduce((acc, channel) => acc + channel.value, 0);
                  const hasRightAccount = channels.length > 0;
                  const hasRightTotal = totalInRightAccount === payment.amazonCode.value;
                  return (
                    <tr className={hasRightAccount ? (hasRightTotal ? '' : 'warning') : 'fraud'} key={i}>
                      <td>{payment.code}</td>
                      <td>
                        {payment.channels.map((channel, x)=> (
                          <span key={x}>{channel.type} - {channel.account} - ${channel.value}</span>
                        ))}
                      </td>
                      <td>xxxx-xxxxxx-{payment.amazonCode.code}</td>
                      <td className={hasRightTotal ? '' : 'warning'}>{payment.amazonCode.value}</td>
                    </tr>
                  );
                })}
                </tbody>

              </table>
            </div>
          )}
        </div>
      </Modal>
    ) : null;
  }
}

export default AmazonCrossCheckView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/AmazonCrossCheck/AmazonCrossCheck.view.js